module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-Regular.5bb7da0.woff";